module.exports = __webpack_public_path__ + "img/گوشه تیز.039a0538.png";